import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'
import ShapesService from '@/services/ShapesService';
import PathUtils from '@/services/PathUtils';
import PainterService from '@/services/PainterService';
import ConversionService from '@/services/ConversionService';
import paper from 'paper';

import store from '@/store';

class Composition extends BaseModel {
    constructor(data, options) {
        super(data, options);
    }
  // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'Composition';
  // Define default properties here
    static instanceDefaults() {
    return {
        shapes: [],
        errors: [],
        options: {},
        solidItems: null,
        cuttablePaths: null,
        stats: {},
    }
  }
}
const servicePath = 'compositions'
const servicePlugin = makeServicePlugin({
    Model: Composition,
    service: feathersClient.service(servicePath),
    servicePath
})


// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
    after: {
        all: [],
        find: [],
        get: [
            async context => {
                paper.project.layers.selectable.removeChildren();
                let composition = context.result;

                if (composition.importId) {
                    let dxfImport = await feathersClient.service('dxf-imports').get(composition.importId);
                    if (dxfImport) {
                        store.dispatch('setMode', 'blueprint');
                        await ConversionService.loadDxfImport(dxfImport);
                    }
                }

                if (store.getters.dxfUrl) {
                    await ConversionService.importDxfUrl(store.getters.dxfUrl)
                }

                store.commit('SET_PRODUCT_PSID', composition.productPsid);
                store.commit('SET_THICKNESS_PSID', composition.thicknessPsid);
                store.commit('SET_CUSTOMER_PSID', composition.customerPsid);
                store.commit('SET_CART_PSID', composition.cartPsid);
                store.commit('SET_CUTTING_OPTIONS', composition.cuttingOptions);
                store.commit('SET_PIECES', composition.pieces);
                store.commit('SET_TOTAL_PRICE', composition.totalPrice);

                let id = 0;
                if (composition.shapes && composition.shapes.length > 0) {
                    composition.shapes.forEach(shape => {
                        ShapesService.importShape(shape);
                        if (shape.id >= id) id = shape.id;
                    });
                    store.commit('UPDATE_SHAPES', composition.shapes);
                }

                store.commit('INCREMENT_NEXT_ID', id + 1);

                store.commit('SET_COMPOSITION_ID', composition._id);

                if (!composition.importId) {
                    await PainterService.repaint(composition);
                }
                PathUtils.autoZoom();

                console.info('Composition loaded : ' + composition._id);
            }],
        create: [
            async context => {
                let composition = context.result;
                store.commit('SET_CUTTING_OPTIONS', composition.cuttingOptions);
                store.dispatch('setCompositionId', composition._id);

                console.info('Composition created : ' + composition._id);

                if (store.getters.dxfUrl) {
                    await ConversionService.importDxfUrl(store.getters.dxfUrl);
                }
                PathUtils.autoZoom();

                if (window.obelix.onCreated) window.obelix.onCreated(composition);
            }
        ],
        update: [
            async context => {
                if ('query' in context.params) {
                    if ('changeQuantity' in context.params.query && context.params.query.changeQuantity !== null && context.params.query.changeQuantity !== undefined) {
                        store.commit('SET_SHOW_ALERT_QUANTITY', false);
                    }else{
                        store.commit('SET_SHOW_ALERT_QUANTITY', true);
                    }
                }else{
                    store.commit('SET_SHOW_ALERT_QUANTITY', true);
                }
                paper.project.layers.selectable.removeChildren();
                let composition = context.result;
                composition.shapes.forEach(shape => {
                    ShapesService.importShape(shape);
                });
                store.commit('SET_CUTTING_OPTIONS', composition.cuttingOptions);
                store.commit('UPDATE_SHAPES', composition.shapes);
                store.commit('SET_PIECES', composition.pieces);
                store.commit('SET_TOTAL_PRICE', composition.totalPrice);
                store.dispatch('setAutocorrectionsList', composition.autocorrects);
                await PainterService.repaint(composition);
            }],
        patch: [
            async context => {
                if (paper.project == null) return;
                if ('query' in context.params) {
                    if ('changeQuantity' in context.params.query && context.params.query.changeQuantity !== null && context.params.query.changeQuantity !== undefined) {
                        store.commit('SET_SHOW_ALERT_QUANTITY', false);
                    }else{
                        store.commit('SET_SHOW_ALERT_QUANTITY', true);
                    }
                }else{
                    store.commit('SET_SHOW_ALERT_QUANTITY', true);
                }
                paper.project.layers.selectable.removeChildren();
                let composition = context.result;
                composition.shapes.forEach(shape => {
                    ShapesService.importShape(shape);
                });
                store.commit('SET_CUTTING_OPTIONS', composition.cuttingOptions);
                store.commit('UPDATE_SHAPES', composition.shapes);
                store.commit('SET_PIECES', composition.pieces);
                store.commit('SET_TOTAL_PRICE', composition.totalPrice);
                store.dispatch('setAutocorrectionsList', composition.autocorrects);
                await PainterService.repaint(composition);
            }],
        remove: []
    },
    error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
    }
})


export default servicePlugin
